import type { LngLatBounds } from 'maplibre-gl';

/**
 * Checks if the child bounds are contained within the parent bounds.
 */
export function areBoundsContained(childBounds: LngLatBounds, parentBounds: LngLatBounds): boolean {
	return childBounds.toArray().every(point => parentBounds.contains(point));
}
